"use client";

import { useEffect } from "react";
import "./globals.css";

// global-error replaces the entire app, including the root layout — it
// can't rely on anything layout.tsx normally provides, so it declares its
// own <html>/<body> and keeps its markup and styling dependency-free. The
// inline style attributes are a redundant fallback in case the stylesheet
// itself fails to load, since this is the last line of defense if
// everything else in the app has broken.
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        className="bg-background text-foreground"
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "24px",
          backgroundColor: "#ffffff",
          color: "#0a0a0a",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 32 }}>LastRedirect</div>
        <h2 style={{ fontWeight: 800, fontSize: 28, margin: "0 0 12px" }}>
          Something went badly wrong.
        </h2>
        <p style={{ opacity: 0.75, maxWidth: 440, margin: "0 0 24px" }}>
          Try reloading the page. If it keeps happening, the issue is on our end.
        </p>
        <button
          onClick={retry}
          style={{
            background: "#171717",
            color: "#ffffff",
            fontWeight: 800,
            fontSize: 14,
            padding: "8px 16px",
            border: 0,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
